import React from "react";
import { Field, UseFieldConfig } from "react-final-form";
import FormSelectCustom, { FormSelectCustomProps } from "ui/Form/SelectCustom";

type Props = FormSelectCustomProps & UseFieldConfig<string> & { sortValue?: boolean };

const SelectCustomField: React.FC<Props> = ({
    labelProps,
    fieldGroupProps,
    fieldControlProps,
    adornmentStart,
    adornmentEnd,
    inputProps,
    infoMessage,
    sortValue,
    ...fieldProps
}) => {
    return (
        <Field name={inputProps.name} {...fieldProps}>
            {({ input, meta }) => {
                return (
                    <FormSelectCustom
                        error={!!(meta.error || meta.submitError)}
                        errorMessage={meta.error || meta.submitError}
                        labelProps={labelProps}
                        fieldGroupProps={fieldGroupProps}
                        fieldControlProps={fieldControlProps}
                        adornmentStart={adornmentStart}
                        adornmentEnd={adornmentEnd}
                        inputProps={Object.assign({}, input, inputProps)}
                        infoMessage={infoMessage}
                        sortValue={sortValue}
                    />
                );
            }}
        </Field>
    );
};

export default SelectCustomField;
